var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"text-align":"right"}},[_c('Input',{staticStyle:{"width":"300px"}}),_c('Button',{staticStyle:{"margin-left":"10px"},attrs:{"type":"primary"}},[_vm._v("查询")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }